import {Component, OnInit, TemplateRef, ViewChild, ChangeDetectionStrategy} from "@angular/core";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Router} from "@angular/router";
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {UserService} from "../../../services/user.service";
import {User} from "../../../models/user";
import {AuthService} from "../../../services/auth.service";
import {CookieService} from "ngx-cookie-service";

@Component({
    selector: 'app-parcours-travaux-call-to-action-modal',
    templateUrl: './call-to-action-modal.html',
    styleUrls: ['./call-to-action-modal.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class callToActionModalComponent implements OnInit {

  @ViewChild('callToActionModal') confirmationModalTemplate: TemplateRef<any>;
  private modal: NgbModalRef;
  baseApiUrl: string = environment.api.baseUrl;

  constructor(
    public modalService: NgbModal,
    private _router: Router,
    private http: HttpClient,
    private userService: UserService,
    private authService: AuthService,
    private cookieService: CookieService,
  ) {
  }

  ngOnInit(): void {
    if (this.cookieService.get('call-to-action-parcours-travaux-modal')) {
      return;
    }
    this.cookieService.set('call-to-action-parcours-travaux-modal', "1")

    this.authService.isAuthenticated().then((authenticated) => {
      if (authenticated) {
        this.userService.load().then((user) => {
          if (!user.ignoreParcoursTravauxModal) {
              this.http.get(`${this.baseApiUrl}projet-travaux-poll/display-poll-modal`).toPromise().then(data => {
              if (!data) {
                this.modal = this.modalService.open(this.confirmationModalTemplate, {size: 'lg'});
              }
            });
          }
        });
      }
    });
  }

  goToParcoursTravaux() {
    this._router.navigate(['parcours-travaux']);
    this.close();
  }

  skipPoll() {
    this.ignoreModal();
  }

  close() {
    this.modal.dismiss();
  }

  private ignoreModal() {
    this.close();
    this.http.get(`${this.baseApiUrl}profile/ignore-parcours-travaux-modal`).toPromise().then(data => {
    });
  }
}
